import { generateServiceId } from "@core/domains/identity";

export const BILLING_SERVICE = {
  ID: generateServiceId("billing"),
  LABEL: "billing",
} as const;
